<template>
  <div class="headerNav">
    <div class="navBlock">
      <div class="navItems">
        <div
          class="navItems"
          v-for="(component, position) in selectedComponents"
          :key="position"
        >
          <div
            class="navItem text"
            :class="{
              disabledNav: !component.selected,
              activeItem: currentComponent.name === component.name
            }"
            @click="changeComponent(component.id)"
          >
            {{
              getTranslation(
                $store,
                "MenuComponent",
                "display_name",
                component.id,
                component.name
              )
            }}
          </div>
          <div
            class="arrowBlock"
            v-if="position !== selectedComponents.length - 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="26px"
              viewBox="0 -960 960 960"
              width="26px"
              fill="var(--app_color_main)"
            >
              <path d="M472-480 288-664l88-88 272 272-272 272-88-88 184-184Z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { toPrintable, comboPrice } from "@/utils/pricing";
import { createNewObject } from "@/utils/products";
import { getTranslation } from "@/utils/helpers";
import { isEmpty } from "lodash";

export default {
  props: { noprices: Boolean, currentComponent: Object },
  computed: {
    ...mapGetters({
      activeCombo: "ACTIVE_COMBO",
      productsList: "PRODUCTS",
      project: "PROJECT"
    }),
    selectedComponents() {
      const newArray = createNewObject(this.activeCombo.components);
      return newArray.sort((a, b) => a.order - b.order);
    }
  },
  created() {
    const selected = [];
    const unselected = [];
    this.activeCombo.components.forEach(item => {
      if (item.selected) {
        selected.push(item.name);
      } else {
        unselected.push(item.name);
      }
    });
    const order = [...selected, ...unselected];
    order.forEach((ord, index) => {
      this.activeCombo.components.forEach(item => {
        if (item.name === ord) {
          this.$set(item, "order", index + 1);
        }
      });
    });
  },
  methods: {
    getTranslation,
    comboPrice,
    toPrintable,
    ...mapActions({ logAudit: "LOG_AUDIT" }),
    hasIngredientGroups(product) {
      if (product && product.ingredients) {
        const filtered = Object.keys(product.ingredients)
          .filter(key => !["default"].includes(key))
          .reduce((obj, key) => {
            return {
              ...obj,
              [key]: product.ingredients[key]
            };
          }, {});
        return !isEmpty(filtered);
      } else {
        return false;
      }
    },
    changeComponent: function(id) {
      const obj = {
        ...this.activeCombo,
        components: this.activeCombo.components.map(item => ({ ...item }))
      };
      let abort = false;
      obj.components.forEach(item => {
        if (item.id === id) {
          if (this.hasIngredientGroups(item.selected)) {
            //header navs with ingredientGroups are non clickable.
            abort = true;
            return;
          }
          this.logAudit({
            category: "COMBO",
            event: "REMOVE_COMPONENT",
            data: item.selected
          });
          delete item.selected;
        }
      });
      if (abort) return;
      this.setActiveCombo(obj);
      this.$emit("changeComponent", { id });
    },
    ...mapMutations({
      setActiveCombo: "SET_ACTIVE_COMBO"
    })
  }
};
</script>
<style lang="scss" scoped>
.invisible {
  opacity: 0;
}

.headerNav {
  margin: var(--component_combo_headerNav_headerNav_margin);
  position: relative;
  z-index: 15;
}
.navTitle {
  letter-spacing: var(--app_letter-spacing_dense);
  color: var(--component_combo_headerNav_navTitle_color);
  font-family: var(--component_combo_headerNav_navTitle_font-family);
  margin-bottom: 20px;
}
.navItem {
  background: var(--component_combo_headerNav_navItem_background);
  border-radius: var(--component_combo_headerNav_navItem_border-radius);
  /* width: 192px; */
  padding: 0 16px;
  height: 35px;
  font-family: var(--component_combo_headerNav_navItem_font-family);
  font-size: var(--component_combo_headerNav_navItem_font-size);
  text-transform: var(--component_combo_headerNav_navItem_text-transform);
  letter-spacing: var(--app_letter-spacing_dense);
  display: flex;
  justify-content: center;
  align-items: center;
}
.navArrow {
  height: 16px;
  width: 16px;
  background-image: var(--component_combo_headerNav_navArrow_background_img);
  background-size: contain;
  background-repeat: no-repeat;
}
.navItems {
  display: flex;
  flex-wrap: wrap;
}
.disabledNav {
  filter: saturate(0);
  color: var(--component_combo_headerNav_disabledNav_color);
}
.arrowBlock {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: 10px;
}
.navPrice {
  font-family: var(--app_font-family-light);
  color: #3d3d3d;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 33px;
  padding: 20px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navBlock {
  display: flex;
  justify-content: center;
}
.activeItem {
  background: var(--component_combo_headerNav_activeItem_background);
  color: var(--component_combo_headerNav_activeItem_color);
  filter: saturate(1);
}
</style>
